const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Fields collected only from new visitors. Returning leads attach to their
// existing lead, so only name + concern (+ privacy) are required from them;
// company / address / phone come from the lead on file.
const FULL_ONLY_FIELDS = [
  'company_name',
  'street',
  'house_number',
  'zip_code',
  'city',
  'phone',
];

export function isValidEmail(email) {
  return typeof email === 'string' && EMAIL_RE.test(email.trim());
}

// Returns a map of { field: reason }, where reason is 'required' or 'email'.
// The component maps reasons to localized messages.
export function getBookingFormErrors(formData, isReturning) {
  const errors = {};
  const trimmed = (key) => String(formData?.[key] ?? '').trim();

  if (!trimmed('first_name')) errors.first_name = 'required';
  if (!trimmed('last_name')) errors.last_name = 'required';
  if (!isValidEmail(formData?.email)) errors.email = 'email';
  if (!formData?.privacy_accepted) errors.privacy_accepted = 'required';

  if (!isReturning) {
    FULL_ONLY_FIELDS.forEach((field) => {
      if (!trimmed(field)) errors[field] = 'required';
    });
  }

  return errors;
}
